import { Box, Button, Container, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Routes } from 'constants/routes.constants';

import Link from 'components/@common/Link';
import LinkUnstyled from 'components/@common/LinkUnstyled';
import AppCompactNavigation from 'components/@navigation/AppCompactNavigation';

const RequestedScreen = () => {
  return (
    <AppCompactNavigation>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: { xs: 'flex', md: 'grid' },
            gridTemplateColumns: '6fr 1fr 5fr',
            flexDirection: { xs: 'column', md: 'row' },
            flex: '1',
          }}
        >
          <Box
            sx={{
              flex: '1',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography variant="h6" component="h1">
              <FormattedMessage id="unsupported_device.requested.title" />
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'text.secondary',
                mt: 1,
              }}
            >
              <FormattedMessage
                id="unsupported_device.requested.description"
                values={{
                  br: <br />,
                  a: (msg) => (
                    <Box
                      sx={{
                        direction: 'ltr /*! @noflip */',
                        display: 'inline-block',
                      }}
                      component="span"
                    >
                      <Link href={`tel:${msg}`}>{msg}</Link>
                    </Box>
                  ),
                }}
              />
            </Typography>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
            }}
          />
          <Button
            variant="outlined"
            color="secondary"
            component={LinkUnstyled}
            href={Routes.Home}
            sx={{ width: { xs: '100%', md: 'auto' }, mb: 2 }}
          >
            <FormattedMessage id="error.back.home.link" />
          </Button>
        </Box>
      </Container>
    </AppCompactNavigation>
  );
};

export default RequestedScreen;
